import { supabase } from './api'

export const revalidate = 0

export async function getAllData() {
	const { data, error } = await supabase.from('gradeinmonths').select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getStudentIdData(id) {
	const prm = `studentId.eq.${id},studentId.is.null`
	const { data, error } = await supabase.from('gradeinmonths').select().or(prm)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getDataWithType(type) {
	const { data, error } = await supabase.from('gradeinmonths').select().eq('type', type)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('gradeinmonths').select().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getDataForMonths(studentId, month) {
	const { data, error } = await supabase.from('gradeinmonths').select().eq('studentId', studentId).eq('month', month)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('gradeinmonths').insert(adata).select()
	if (error) {
		throw new Error('Failed to fetch data')
	}
	return data
}

export async function updateData(udata) {
	const { id, ...patch } = udata
	if (id === undefined || id === null) {
		throw new Error('update requires id')
	}
	// DB DEFAULT does not run on UPDATE — set explicitly so Rigor “most recently saved” uses fresh timestamps
	const payload = { ...patch, updated_at: new Date().toISOString() }

	const { data, error } = await supabase.from('gradeinmonths').update(payload).eq('id', id).select()
	if (error) {
		throw new Error(error.message || 'Failed to update grade')
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('gradeinmonths').delete().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}
